import { Grid, ListItemText } from "@mui/material";

const DatosSiniestroCard = ({ data }) => {
  return (
    <>
      <Grid
        direction="row"
        container
        spacing={1}
      >
        <Grid item xs={6}>
          <ListItemText
            primary="Número Siniestro ART"
            secondary={
              data?.nroSiniestroART ? data.nroSiniestroART : "Sin Información"
            }
          />
        </Grid>
        <Grid item xs={6}>
          <ListItemText
            primary="Tipo de Siniestro"
            secondary={
              data?.tipoSiniestro ? data.tipoSiniestro : "Sin Información"
            }
          />
        </Grid>
        <Grid item xs={6}>
          <ListItemText
            primary="DNI"
            secondary={data?.nroDocumento ? data.nroDocumento : "Sin Información"}
          />
        </Grid>
        <Grid item xs={6}>
          <ListItemText
            primary="Nombre"
            secondary={
              data?.apellidoNombre ? data.apellidoNombre : "Sin Información"
            }
          />
        </Grid>
        <Grid item xs={12}>

          <ListItemText
            primary="Descripción del Siniestro"
          />
          <ListItemText
            sx={{ p: 1 }}
            secondary={data?.comoOcurrioAccidente ?? "Sin Información"}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DatosSiniestroCard;
